if (typeof FeaturedProductCarousel === 'undefined') {
    class FeaturedProductCarousel extends HTMLElement {
        constructor() {
            super();
            this.handleTabPanelChanged = this.handleTabPanelChanged.bind(this);
        }

        connectedCallback() {
            document.addEventListener('tabby:panel:changed', this.handleTabPanelChanged);
            this.initSwiper();
        }

        disconnectedCallback() {
            document.removeEventListener('tabby:panel:changed', this.handleTabPanelChanged);
            this.destroySwiper();
        }

        isPanelVisible() {
            const panel = this.closest('[role="tabpanel"]');
            return !panel || !panel.hidden;
        }

        getSwiperConfig(swiperContainer) {
            const slideCount = swiperContainer.querySelectorAll('.swiper-slide').length;
            const maxPerView = Math.max(
                Number(this.dataset.cardsPerView) || 1,
                Number(this.dataset.cardsPerViewTablet) || 1,
                Number(this.dataset.cardsPerViewMobile) || 1
            );

            return {
                a11y: true,
                slidesPerView: Number(this.dataset.cardsPerViewMobile),
                loop: slideCount > maxPerView,
                loopAdditionalSlides: maxPerView,
                watchOverflow: true,
                spaceBetween: 16,
                pauseOnMouseEnter: false,
                watchSlidesProgress: true,
                preventClicks: false,
                preventClicksPropagation: false,
                navigation: {
                    prevEl: this.querySelector('.swiper-prev'),
                    nextEl: this.querySelector('.swiper-next')
                },
                mousewheel: {
                    enabled: !window.isSafari(),
                    forceToAxis: window.isSafari() ? false : true,
                    thresholdDelta: 10
                },
                breakpoints: {
                    768: {
                        slidesPerView: Number(this.dataset.cardsPerViewTablet),
                    },
                    1025: {
                        slidesPerView: Number(this.dataset.cardsPerView),
                    }
                }
            };
        }

        initSwiper(force = false) {
            const swiperContainer = this.querySelector('.swiper');
            if (!swiperContainer || this.swiper) return;
            if (!force && !this.isPanelVisible()) return;

            whenReady('Swiper', () => {
                if (!this.isConnected || this.swiper) return;
                if (!force && !this.isPanelVisible()) return;

                try {
                    this.swiper = new Swiper(swiperContainer, this.getSwiperConfig(swiperContainer));
                } catch (error) {
                    console.error('Failed to initialize Swiper:', error);
                }
            });
        }

        cleanupSwiperContainer() {
            const swiperContainer = this.querySelector('.swiper');
            if (!swiperContainer) return;

            swiperContainer.classList.remove(
                'swiper-initialized',
                'swiper-horizontal',
                'swiper-vertical',
                'swiper-backface-hidden',
                'swiper-watch-progress'
            );
            swiperContainer.removeAttribute('style');
        }

        reinitSwiper(force = false) {
            this.destroySwiper();
            this.cleanupSwiperContainer();
            this.initSwiper(force);
        }

        destroySwiper() {
            if (this.swiper) {
                this.swiper.destroy(true, true);
                this.swiper = null;
            }
        }

        handleTabPanelChanged(event) {
            const activeContent = event?.detail?.activeContent;
            if (!activeContent || !activeContent.contains(this)) return;

            requestAnimationFrame(() => {
                if (!this.swiper) {
                    this.initSwiper();
                    return;
                }

                this.swiper.update();
                if (typeof this.swiper.updateAutoHeight === 'function') {
                    this.swiper.updateAutoHeight(0);
                }
            });
        }

    }

    if (!window.customElements.get('featured-product-carousel')) {
        window.customElements.define('featured-product-carousel', FeaturedProductCarousel);
    }

    function reinitSectionCarousels(section) {
        if (!section) return;

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                section.querySelectorAll('featured-product-carousel').forEach((carousel) => {
                    carousel.reinitSwiper();
                });
            });
        });
    }

    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        document.addEventListener('shopify:section:load', (event) => {
            reinitSectionCarousels(event.target);
        });
    }
}